export default __webpack_public_path__ + "8aa2403f43bbea7a880c29215e2665a1.svg";